module.exports = __webpack_public_path__ + "static/media/Ranvijay Sachan - Coverletter.b6fbbf4e.pdf";